<template>
  <b-card-actions action-collapse title="Instant estimation list">
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <!-- <label class="mr-1">Search</label> -->
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
          </div>
        </b-form-group>
      </div>
    </div>

    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-quote"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
<!-- 
              <b-dropdown-item @click="previewInstantQuote(props.row._id)">
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span>Display Instant quote</span>
              </b-dropdown-item>
              
              <b-dropdown-item @click="UpdateInstantQuote(props.row._id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Update Instant quote</span>
              </b-dropdown-item> -->

              <b-dropdown-item @click="DeleteInstantQuote(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete Instant quote</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

 <span v-else-if="props.column.field == 'state'">
        <p v-if="props.row.state=='accepted'">  
          <b-badge variant="success">
        Accepted
        </b-badge>
        </p>
        <p v-if="props.row.state=='refused'">
            <b-badge variant="danger">
        Refused
      </b-badge>
        </p>
        <p v-if="props.row.state=='pending'">  <b-badge variant="warning">
        Pending
        </b-badge></p>

      </span>
      <span v-else-if="props.column.field == 'customer'">
        <p v-if="props.row.customer">{{ props.row.customer.email }} <br> {{ props.row.customer.customer.firstName }} {{ props.row.customer.customer.lastName }}</p>
      </span>
      <span v-else-if="props.column.field == 'containers'">
        <table>
          <tr>
            <th>Type</th>
            <th>Quantity</th>
            <th>Weight</th>
            <th>Shipper owned container</th>
          </tr>
          <tr v-for="(container, index) in props.row.containers" :key="index">
            <td>{{ container.containerType }}</td>
            <td>{{ container.quantity }}</td>
            <td>{{ container.weight }}KG</td>
            <td v-if="container.isOwnedByShipper">SOC</td>
            <td v-else>COC</td>
          </tr>
        </table>
      </span>
       <span v-else-if="props.column.field == 'departurePortAgent'">
          <p >{{ props.row.departurePortAgent.agent.seaPort }}</p>
        </span>
        <span v-else-if="props.column.field == 'arrivalPortAgent'">
          <p>{{ props.row.arrivalPortAgent.agent.seaPort }}</p>
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['5', '10', '15']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  
  </b-card-actions>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BModal,
  VBModal,
  BForm,
  BDropdown,
  BDropdownItem,
  BTooltip,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";
import moment from 'moment';
import { BBadge } from "bootstrap-vue";

export default {
  components: {
    BBadge,
    BDropdown,
    BDropdownItem,
    BTooltip,
    BModal,
    VBModal,
    BForm,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      show: false,
      pageLength: 5,
      pageLengthModal: 5,
      dir: false,
     
    columns: [
         {
          label: "Action",
          field: "action",
          sortable: false,
        },
        //  {
        //   label: "State",
        //   field: "state",
        //   filterOptions: {
        //     enabled: true,
        //     placeholder: "State",
        //   },
        // },
        
           {
          label: "Customer",
          field: "customer",
          filterOptions: {
            enabled: true,
            placeholder: "Customer",
          },
        },
        {
          label: "From",
          field: "loadingPort",
          filterOptions: {
            enabled: true,
            placeholder: "From",
          },
        },
        {
          label: "To",
          field: "dischargePort",
          filterOptions: {
            enabled: true,
            placeholder: "To",
          },
        },
        {
          label: "Commodity",
          field: "commodity",
          filterOptions: {
            enabled: true,
            placeholder: "Comodity",
          },
        },
        /*{
          label: "Temperature Control",
          field: "requiresTemperatureControl",
          filterOptions: {
            enabled: true,
            placeholder: "Temperature Control",
          },
        },
        {
          label: "Temperature",
          field: "TemperatureControl",
          filterOptions: {
            enabled: true,
            placeholder: "Temperature",
          },
        },*/
        {
          label: "Special Equipment",
          field: "requiresSpecialEquipment",
          filterOptions: {
            enabled: true,
            placeholder: "Special Equipment",
          },
        },
        {
          label: "Height",
          field: "specialEquipment.height",
          filterOptions: {
            enabled: true,
            placeholder: "Height",
          },
        },
        {
          label: "Width",
          field: "specialEquipment.width",
          filterOptions: {
            enabled: true,
            placeholder: "Width",
          },
        },
        {
          label: "Length",
          field: "specialEquipment.length",
          filterOptions: {
            enabled: true,
            placeholder: "Length",
          },
        },
        {
          label: "Dangerous Cargo",
          field: "dangerousCargo",
          filterOptions: {
            enabled: true,
            placeholder: "Dangerous Cargo",
          },
        }, 
        {
          label: "Classe",
          field: "commodityClass",
          filterOptions: {
            enabled: true,
            placeholder: "Classe",
          },
        },  
        {
          label: "Un",
          field: "commodityUn",
          filterOptions: {
            enabled: true,
            placeholder: "Un",
          },
        },  
        {
          label: "Containers",
          field: "containers",
          filterOptions: {
            enabled: true,
            placeholder: "Containers",
          },
        },    
        {
          label: "Pricing Date",
          field: "estimationDate",
          filterOptions: {
            enabled: true,
            placeholder: "Pricing Date",
          },
          formatFn: (value) => {
            return moment(value).format('MM/DD/YYYY');
          },
        },
        {
          label: "Estimation Price",
          field: "estimationPrice",
          filterOptions: {
            enabled: true,
            placeholder: "Estimation Price",
          },
        },    
      ],      
      rows: [],
      rowModal: [],
      searchTerm: "",
    };
  },
  watch: {
    '$route.query.id': 'getAllDataQuote',
  },  
  async created() {
    await this.getAllDataQuote();
  },
  methods: {
    async getAllDataQuote() {
      if (this.$route.query.id) {
        await axios.get("https://mtl-feeder-nodejs.onrender.com/api/instant-estimations?user=" +this.$route.query.id)
        .then((response) => {
          this.rows = response.data.data.reverse();
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
      }
      else {
        await axios.get("https://mtl-feeder-nodejs.onrender.com/api/instant-estimations")
        .then((response) => {
          this.rows = response.data.data.reverse();
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
      }
    },
    advanceSearch(val) {
      this.searchTerm = val;
    },
    // table Format
    tableFormat: function (value) {
      const table = value.map((element) => {
        return element.label;
      });
      return table.toString();
    }, 
    DeleteInstantQuote(id) {
      this.$swal({
        title: "You really want to delete this quote ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm !",
        cancelButtonText: "Cancel !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          var payload = {
            deletedBy: JSON.parse(localStorage.getItem("userData"))._id,
          };
          axios.delete(`https://mtl-feeder-nodejs.onrender.com/api/instant-estimations/${id}`)
            .then((response) => {
              this.getAllDataQuote();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Quote is deleted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error while deleting`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action canceled",
            icon: "error",
            confirmButtonText: "Close !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    }
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style>
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}
.btn-delete-all {
  margin-left: 3%;
}

.p-description {
  height: 60px;
  width: 250px;
  overflow: auto;
}
.barcode-size svg {
  height: 80px;
}
</style>
